import React from "react";
import {useTranslation} from "react-i18next";
import {gql} from "@apollo/client";
import DeviceStatisticTemplate from "./DeviceStatisticTemplate";
import {formatToLocalTime} from "../utils/dateUtils";
import WaterDropIcon from "@mui/icons-material/WaterDrop";

const PAGINATE_MAKMINI_STAT = gql`
    query PaginateMakminiTelemetry($pagination: Pagination!, $sortBy: [SortBy!], $criteria: DeviceMakminiTelemetryCriteria) {
        paginateDeviceMakminiTelemetry(pagination: $pagination, sortBy: $sortBy, criteria: $criteria) {
            pageInfo {
                totalElements
                totalPages
                numberOfElements
                pageNumber
                pageSize
            }
            content {
                id
                serialNumber
                locationName
                customerName
                resellerName
                timestamp
                updatedTimestamp
                temperature
                humidity
                flowA
                flowB
                conductivityA
                conductivityB
                waterTemperatureA
                waterTemperatureB
            }
        }
    }
`;

export default function MakminiTelemetry() {
    const {t} = useTranslation();
    const columns = [
        {field: "serialNumber", label: t("devicePageMakmini.columns.serial"), sortable: true},
        {field: "resellerName", label: t("devicePageMakmini.columns.reseller"), sortable: true},
        {field: "customerName", label: t("devicePageMakmini.columns.customer"), sortable: true},
        {field: "locationName", label: t("devicePageMakmini.columns.location"), sortable: true},
        {field: "temperature", label: t("devicePageMakmini.columns.temperature")},
        {field: "humidity", label: t("devicePageMakmini.columns.humidity")},
        {field: "flowA", label: t("devicePageMakmini.columns.flowA")},
        {field: "flowB", label: t("devicePageMakmini.columns.flowB")},
        {field: "conductivityA", label: t("devicePageMakmini.columns.conductivityA")},
        {field: "conductivityB", label: t("devicePageMakmini.columns.conductivityB")},
        {field: "waterTemperatureA", label: t("devicePageMakmini.columns.waterTempA")},
        {field: "waterTemperatureB", label: t("devicePageMakmini.columns.waterTempB")},
        {
            field: "timestamp",
            label: t("devicePageMakmini.columns.timestamp"),
            sortable: true,
            format: (v) => (v ? formatToLocalTime(v) : "-"),
            nowrap: true,
            sticky: "right",
            width: 180,
        },
    ];

    return (
        <DeviceStatisticTemplate
            title={t("makminiTelemetry.title")}
            subtitle={t("makminiTelemetry.subtitle")}
            query={PAGINATE_MAKMINI_STAT}
            columns={columns}
            icon={<WaterDropIcon/>}
        />
    );
}
